import { CategoryTree } from '@/fo/api/magento';

import { CategoryParamsType, DefaultCategoryPath } from '../types';

const toArray = (val?: string | number | (string | number)[]) => {
  if (val == null) return [];
  return Array.isArray(val) ? val.map(String) : [String(val)];
};

type GetCategoryTypeProps = {
  defaultCategoryPath?: DefaultCategoryPath;
  category_url_path?: string[] | string;
  category_id?: string[] | string;
  category_uid?: string[] | string;
  category?: CategoryTree;
};

export const getCategoryType = ({
  category_url_path,
  category_id,
  category_uid,
  defaultCategoryPath,
  category
}: GetCategoryTypeProps): CategoryParamsType => {
  const defaultUrlPath = category?.url_path || defaultCategoryPath?.url;
  const defaultUid = category?.uid || defaultCategoryPath?.uid;
  const defaultId = category?.id || defaultCategoryPath?.id;

  if (category_url_path) {
    const arr = toArray(category_url_path);
    return { category_url_path: arr.length > 1 ? arr : arr[0] };
  }
  if (category_uid) {
    const arr = toArray(category_uid);
    return { category_uid: arr.length > 1 ? arr : arr[0] };
  }
  if (category_id) {
    const arr = toArray(category_id);
    return { category_id: arr.length > 1 ? arr : arr[0] };
  }
  if (defaultUid) return { category_uid: defaultUid };
  if (defaultUrlPath) return { category_url_path: defaultUrlPath };
  if (defaultId) return { category_id: String(defaultId) };
  return {};
};
